import Icon from '@material-ui/icons/BookmarkBorder';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog, Filter, ResourceList } from '../../../../controllers';
import { TextField } from '../../../../fields';
import { BooleanInput, TextInput } from '../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="icon"
        />
        <TextInput
          source="content"
        />
        <TextInput
          source="line"
        />
        <TextInput
          source="position"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ mission_step_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="icon"
        />
        <TextInput
          source="content"
        />
        <TextInput
          source="line"
        />
        <TextInput
          source="position"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="icon"
        />
        <TextField
          source="content"
        />
        <TextField
          source="line"
        />
        <TextField
          source="position"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
